const STORAGE_KEY = "browser-compat:dismissed";

export function isBrowserCompatBannerDismissed(): boolean {
  if (typeof window === "undefined") return false;
  try {
    return localStorage.getItem(STORAGE_KEY) === "1";
  } catch {
    return false;
  }
}

export function dismissBrowserCompatBanner(): void {
  try {
    localStorage.setItem(STORAGE_KEY, "1");
  } catch (error) {
    console.error("Error saving browser compat banner preference:", error);
  }
}
